import { TApiFolder } from "../../../api/endpoints/Folder";
import React, { Fragment } from "react";
import { paths } from "../../../router";
import Link from "../../Navigation/Links/Link";
import { Breadcrumb } from "react-bootstrap";
import { faFolder } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const FolderBreadcrumbs = (props: { currentFolder: TApiFolder | null }) => {
  const { currentFolder } = props;

  return (
    <div className="folder-breadcrumbs">
      <FontAwesomeIcon icon={faFolder} className="folder-icon" />
      <Breadcrumb>
        {
          currentFolder ?
            <Fragment>
              <Breadcrumb.Item as={Link} href={paths.orders} to={paths.orders}>All orders</Breadcrumb.Item>
              <Breadcrumb.Item active>{currentFolder.name}</Breadcrumb.Item>
            </Fragment>
            :
            <Breadcrumb.Item active>All orders</Breadcrumb.Item>
        }
      </Breadcrumb>
    </div>
  )
}

export default FolderBreadcrumbs;
